import axios from "axios";
import { ApiURL } from "../../../setting/GlobleVariable";
import { lowestPriceFromTicketGroups } from "./marketplaceHomeFeaturedFromApi";

/** Fetch TEVO listings and return lowest retail (first price on ticket page). */
export async function fetchTevoListingPrice(eventId) {
  const id = parseInt(String(eventId), 10);
  // Fast path: the server works out the cheapest seat (parking excluded) and
  // caches it, so this is a ~80-byte response instead of every listing.
  try {
    const { data } = await axios.get(`${ApiURL}/transcation/price-summary/${id}`, { timeout: 10000 });
    if (data?.minPrice > 0) return data.minPrice;
  } catch {
    /* older server: fall back to the full listing download */
  }
  try {
    const res = await axios.get(`${ApiURL}/transcation/details/${id}`);
    return lowestPriceFromTicketGroups(res.data?.ticket_groups);
  } catch {
    return 0;
  }
}
